import React from 'react'

import { ActionHeader } from './components/ActionHeader'
import { ActionForm } from './components/ActionForm'
import { CreateActionProvider } from './contexts/action'
import { ActionBody } from './components/ActionBody'

export function CreateActionPage() {
  return (
    <CreateActionProvider>
      <ActionForm>
        <ActionHeader />
        <ActionBody />
      </ActionForm>
    </CreateActionProvider>
  )
}
